import React from "react";
import { WaveyBackground } from "./../shared/WaveyBackground";
import { BubblesBackground } from "./../shared/BubblesBackground";
import { SpeechBubblesBackground } from "./../shared/SpeechBubblesBackground";
import { StarsBackground } from "./../shared/StarsBackground";
import { RetroBackground } from "./../shared/RetroBackground";
import { ConfettiBackground } from "./../shared/ConfettiBackground";
import { GradientBackground } from "./../shared/GradientBackground";
import { DotsBackground } from "./../shared/DotsBackground";
import { DoodlesBackground } from "./../shared/DoodlesBackground";
import { SolidBackground } from "./../shared/SolidBackground";
import { RiAsterisk } from "react-icons/ri";

const BACKGROUNDS = {
  wavey: WaveyBackground,
  bubbles: BubblesBackground,
  speech: SpeechBubblesBackground,
  stars: StarsBackground,
  retro: RetroBackground,
  confetti: ConfettiBackground,
  gradient: GradientBackground,
  dots: DotsBackground,
  doodles: DoodlesBackground,
  solid: SolidBackground,
};

export const Preview = ({ capform, page, previewMode = "desktop" }) => {
  const { welcome_title, welcome_text, prompt_text, collect_avatar, collect_email, collect_job_title, collect_company_name, collect_company_logo, collect_company_team, custom_thanks_page, thanks_url, thanks_text, thanks_title, background_style, background_color } = capform;

  const Background = BACKGROUNDS[background_style] || WaveyBackground;
  const bgColor = background_color || "#3E8DFF";

  const maxWidth = previewMode === "mobile" ? "390px" : "100%";

  return (
    <div className="mx-auto transition-[max-width] duration-300 ease-out" style={{ maxWidth }}>
      <div className="border-[3px] border-black bg-white shadow-[6px_6px_0_rgba(0,0,0,0.18)] overflow-hidden md:h-[calc(100vh-160px)] flex flex-col">
        <div className="flex items-center gap-1.5 px-3 py-2 border-b-[2px] border-black bg-slate-100">
          <span className="block w-2.5 h-2.5 rounded-full bg-[#FF7AAC] border border-black/40" />
          <span className="block w-2.5 h-2.5 rounded-full bg-[#FFD23A] border border-black/40" />
          <span className="block w-2.5 h-2.5 rounded-full bg-[#3EB567] border border-black/40" />
          <div className="ml-3 flex-1 h-5 bg-white border border-black/20 rounded-sm flex items-center px-2">
            <span className="text-[10px] font-bold text-slate-400 truncate">your-site.com</span>
          </div>
        </div>
        <div className="flex relative flex-col items-center bg-gray-50 px-4 overflow-y-auto flex-1 min-h-[400px]">
        <Background bgColor={bgColor} />
        <div className="py-8 sm:pb-20 sm:pt-20 relative my-auto w-full max-w-lg mx-auto">
          <div className="relative rounded-2xl border bg-white shadow-2xl">
            <div className="flex flex-col gap-4">
              {(page == "welcome-page" || page == "settings-page" || page == "design-page") && (
                <div className="p-4 animate__animated animate__slideInUp animate_02s">
                  <h1 className="text-lg font-medium sm:text-3xl">
                    {welcome_title}
                  </h1>
                  <div className="content mt-4" dangerouslySetInnerHTML={{__html: welcome_text}} />
                  <div className="mt-4 flex flex-col gap-2">
                    <button className="group relative inline-flex h-10 items-center justify-center overflow-hidden rounded-md bg-ssblue px-3 py-2 text-white border-2 border-black text-sm">
                      <span className="absolute h-0 w-0 bg-ssblue-alt transition-all duration-300 group-hover:h-full group-hover:w-full"></span>
                      <span className="relative">
                        Record or Upload a Video
                      </span>
                    </button>
                    <button className="group relative inline-flex h-10 items-center justify-center overflow-hidden rounded-md bg-sspurple px-3 py-2 text-white border-2 border-black text-sm">
                      <span className="absolute h-0 w-0 bg-sspurple-alt transition-all duration-300 group-hover:h-full group-hover:w-full"></span>
                      <span className="relative">
                        Record or Upload Audio
                      </span>
                    </button>
                    <button className="group relative inline-flex h-10 items-center justify-center overflow-hidden rounded-md bg-ssorange px-3 py-2 text-white border-2 border-black text-sm">
                      <span className="absolute h-0 w-0 bg-ssorange-alt transition-all duration-300 group-hover:h-full group-hover:w-full"></span>
                      <span className="relative">
                        Write Text
                      </span>
                    </button>
                  </div>
                </div>
              )}
              { page == "thanks-page" && <>
                { custom_thanks_page !== 'Standard Page' ? (
                  <div className="p-4 flex flex-col gap-y-2">
                    Once they have submitted the form, they will be redirected to the following URL: <a className='text-ssblue' href={thanks_url}>{thanks_url}</a>
                  </div>
                ) : (
                  <div className="p-4 animate__animated animate__slideInUp animate_02s">
                    <h1 className="text-lg font-medium sm:text-3xl">
                      {thanks_title}
                    </h1>
                    <div className="content mt-4" dangerouslySetInnerHTML={{__html: thanks_text}} />
                  </div>
                )}
              </>
              }
              {page == "prompt-page" && (
                <div className="p-4 flex flex-col gap-y-2 animate__animated animate__slideInUp animate_02s">
                  <div className="content mt-4" dangerouslySetInnerHTML={{__html: prompt_text}} />
                  <button className="w-md bg-ssblue text-white duration-100 focus:bg-gray-900 disabled:opacity-50 bg-opacity-100 block appearance-none rounded-lg mt-2 text-sm font-medium duration-100 focus:ring-0 px-4 py-2.5">
                    Continue
                  </button>
                </div>
              )}
              {page == "contact-page" && (
                <div className="p-4 flex flex-col gap-y-2 animate__animated animate__slideInUp animate_02s">
                  <div className='flex flex-col gap-y-4'>
                    <div className='grid gap-x-4 grid-cols-1 sm:grid-cols-5'>
                      { collect_avatar !== 'Do not collect' && (
                        <div className='col-span-2'>
                          <label className='mt-4 sm:mt-0 block text-sm font-medium text-gray-500'>
                            <div className="flex items-center gap-2 relative">
                              <span>Your Avatar</span>
                              { collect_avatar === 'Required' && <RiAsterisk className='w-4 h-4 text-ssred' />}
                            </div>
                          </label>
                          <div className="flex items-center gap-2 mt-2">
                            <div className="flex items-center gap-2 relative">
                              <div className="flex items-center space-x-6">
                                <div className="shrink-0 relative h-28 w-28">
                                  <img className="h-28 w-28 object-cover rounded-md cursor-pointer shadow-lg border border-gray-400 border-dotted border-2" src="https://images.shosay.com/placeholder_avatar2.webp" alt="Avatar" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className='col-span-3'>
                        <label className='mt-4 sm:mt-0 block text-sm font-medium text-gray-500'>
                          <div className="flex items-center gap-2 relative">
                            <span>Name</span>
                            <RiAsterisk className='w-4 h-4 text-ssred' />
                          </div>
                        </label>
                        <input type='text' placeholder='Your Name' spellCheck='false'  className= 'border border-gray-300 rounded-md px-3 py-2 w-full placeholder-gray-500 shadow-sm focus:outline-none focus:border-transparent focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-ssblue' />
                      </div>
                    </div>
                    { collect_email !== 'Do not collect' && (
                      <div>
                        <label className='mt-4 sm:mt-0 block text-sm font-medium text-gray-500'>
                          <div className="flex items-center gap-2 relative">
                            <span>Email</span>
                            { collect_email === 'Required' && <RiAsterisk className='w-4 h-4 text-ssred' />}
                          </div>
                        </label>
                        <input type='email' placeholder='hello@example.com' spellCheck='false'  className= 'border border-gray-300 rounded-md px-3 py-2 w-full placeholder-gray-500 shadow-sm focus:outline-none focus:border-transparent focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-ssblue' />
                      </div>
                    )}
                    { collect_job_title !== 'Do not collect' && (
                      <div>
                        <label className='mt-4 sm:mt-0 block text-sm font-medium text-gray-500'>
                          <div className="flex items-center gap-2 relative">
                            <span>Job Title</span>
                            { collect_job_title === 'Required' && <RiAsterisk className='w-4 h-4 text-ssred' />}
                          </div>
                        </label>
                        <input type='text' placeholder='Designer' spellCheck='false'  className= 'border border-gray-300 rounded-md px-3 py-2 w-full placeholder-gray-500 shadow-sm focus:outline-none focus:border-transparent focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-ssblue' />
                      </div>
                    )}
                    { collect_company_name !== 'Do not collect' && (
                      <div>
                        <label className='mt-4 sm:mt-0 block text-sm font-medium text-gray-500'>
                          <div className="flex items-center gap-2 relative">
                            <span>Company</span>
                            { collect_company_name === 'Required' && <RiAsterisk className='w-4 h-4 text-ssred' />}
                          </div>
                        </label>
                        <input type='text' placeholder='Acme Bricks Inc' spellCheck='false'  className= 'border border-gray-300 rounded-md px-3 py-2 w-full placeholder-gray-500 shadow-sm focus:outline-none focus:border-transparent focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-ssblue' />
                      </div>
                    )}
                    { collect_company_team !== 'Do not collect' && (
                      <div>
                        <label className='mt-4 sm:mt-0 block text-sm font-medium text-gray-500'>
                          <div className="flex items-center gap-2 relative">
                            <span>Company Team</span>
                            { collect_company_team === 'Required' && <RiAsterisk className='w-4 h-4 text-ssred' />}
                          </div>
                        </label>
                        <input type='text' placeholder='Design' spellCheck='false'  className= 'border border-gray-300 rounded-md px-3 py-2 w-full placeholder-gray-500 shadow-sm focus:outline-none focus:border-transparent focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-ssblue' />
                      </div>
                    )}
                    { collect_company_logo !== 'Do not collect' && (
                      <div className='col-span-2'>
                        <label className='mt-4 sm:mt-0 block text-sm font-medium text-gray-500'>
                          <div className="flex items-center gap-2 relative">
                            <span>Company Logo</span>
                            { collect_company_logo === 'Required' && <RiAsterisk className='w-4 h-4 text-ssred' />}
                          </div>
                        </label>
                        <div className="flex items-center gap-2 mt-2">
                          <div className="flex items-center gap-2 relative">
                            <div className="flex items-center space-x-6">
                              <div className="shrink-0 relative h-28 w-28">
                                <img className="h-28 w-28 object-cover rounded-md cursor-pointer shadow-lg border border-gray-400 border-dotted border-2" src="https://images.shosay.com/placeholder_avatar.webp" alt="Avatar" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <button className="w-md bg-ssblue text-white duration-100 focus:bg-gray-900 disabled:opacity-50 bg-opacity-100 block appearance-none rounded-lg mt-2 text-sm font-medium duration-100 focus:ring-0 px-4 py-2.5">Continue</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Preview;
